import React, { useEffect, useState } from 'react';
import { subApi } from '../../config/api.config';

const PRODUCT_NAMES = {
    daily_subscription: '데일리',
    all_in_one_subscription: '올인원',
};

const TH = {
    borderBottom: '2px solid #1976d2',
    padding: '10px 8px',
    textAlign: 'center',
    fontWeight: 700,
    color: '#222',
    fontSize: 14,
};
const TD = { padding: '10px 8px', textAlign: 'center', fontSize: 14, color: '#444' };

export function MemberPaymentAttemptsSection({ memberId }) {
    const [attempts, setAttempts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusFilter, setStatusFilter] = useState('');

    useEffect(() => {
        if (!memberId) return;
        setLoading(true);
        const params = new URLSearchParams({ userId: memberId, limit: '50' });
        if (statusFilter) params.set('status', statusFilter);
        subApi
            .get(`/admin/payment-attempts?${params.toString()}`)
            .then(res => setAttempts(res.data?.attempts || []))
            .catch(() => setAttempts([]))
            .finally(() => setLoading(false));
    }, [memberId, statusFilter]);

    return (
        <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                <h3 style={{ fontSize: 18, fontWeight: 600, color: '#1976d2', margin: 0 }}>
                    결제 시도 이력
                </h3>
                <select
                    value={statusFilter}
                    onChange={e => setStatusFilter(e.target.value)}
                    style={{ padding: '4px 8px', fontSize: 13, borderRadius: 4, border: '1px solid #ddd' }}
                >
                    <option value="">전체</option>
                    <option value="failed">실패만</option>
                    <option value="success">성공만</option>
                </select>
            </div>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '24px 0', color: '#666', fontSize: 14 }}>
                    불러오는 중...
                </div>
            ) : attempts.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '24px 0', color: '#999', fontSize: 14 }}>
                    결제 시도 이력이 없습니다.
                </div>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
                    <thead>
                        <tr>
                            <th style={TH}>일시</th>
                            <th style={TH}>상품</th>
                            <th style={TH}>금액</th>
                            <th style={TH}>결과</th>
                            <th style={{ ...TH, textAlign: 'left', width: '40%' }}>실패 사유</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attempts.map((a, i) => (
                            <tr
                                key={a._id || i}
                                style={{
                                    borderBottom: '1px solid #eee',
                                    background: a.status === 'failed' ? '#fff8f8' : '#fff',
                                }}
                            >
                                <td style={TD}>{new Date(a.createdAt).toLocaleString('ko-KR')}</td>
                                <td style={TD}>{PRODUCT_NAMES[a.productId] || a.productId}</td>
                                <td style={TD}>{a.amount?.toLocaleString()}원</td>
                                <td style={TD}>
                                    <span
                                        style={{
                                            padding: '3px 8px',
                                            borderRadius: 10,
                                            fontSize: 12,
                                            fontWeight: 600,
                                            backgroundColor: a.status === 'success' ? '#e8f5e8' : '#fce4e4',
                                            color: a.status === 'success' ? '#2e7d32' : '#c62828',
                                        }}
                                    >
                                        {a.status === 'success' ? '성공' : '실패'}
                                    </span>
                                </td>
                                <td style={{ ...TD, textAlign: 'left', fontSize: 13, color: '#c62828', wordBreak: 'break-word' }}>
                                    {a.status === 'failed' ? (
                                        <>
                                            {a.failCode && (
                                                <span style={{ fontWeight: 600, marginRight: 6 }}>[{a.failCode}]</span>
                                            )}
                                            {a.failReason || '-'}
                                        </>
                                    ) : (
                                        '-'
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
